module.exports = __webpack_public_path__ + "img/kb.b2b2c4a5.png";